import React, {Component} from "react";
import LoaderButton from "../components/LoaderButton";
import "./NewTrainer.css";
import * as columnDefsTrainers from "../libs/columnDefTrainers";
import {AgGridReact} from "ag-grid-react";
import * as userLib from "../libs/user-lib";
import {validateFormTrainer} from "../libs/user-lib";
import * as globalsTrainer from "../libs/globalDefTrainers";
const API = require("../libs/awsApiWrappers");

export default class NewTrainer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: null,
            selectedTrainers: [],

            // make a copy of the JSON structure as the underlying structure is modified
            columnDefs: JSON.parse(JSON.stringify(columnDefsTrainers.columnDefsTrainers)),

            defaultColDef: {
                resizable: true
            },
            style: {
                width: '100%',
                // height: '364px'
                height: '110px'
            },

            isEditor: userLib.isCustomEditor(this.props.currentUser, 'trainer'),
            rowData: []
        };

        // disable tick box
        this.state.columnDefs[0].checkboxSelection = false;

        // update column definition
        columnDefsTrainers.setColDefTrainerForDataEntry(false, this);
    }

    onGridReady = params => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;

        const updateData = data => {
            this.setState({rowData: data});
        };

        updateData(this.state.rowData);
    };

    componentDidUpdate() {
        if (this.gridApi) {
            this.gridApi.refreshCells();
        }
    }

    componentDidMount() {
        if (!this.props.isAuthenticated) {
            return;
        }
        this.props.setUpdateTimeOutListener();
        this.setState({isEditor: userLib.isCustomEditor(this.props.currentUser, 'trainer')});

        if (this.props.trainerToDuplicate && this.props.trainerToDuplicate.length > 0) {
            this.setState({rowData: [this.props.trainerToDuplicate[0]]});
        } else {
            const obj = [{[globalsTrainer.trainerID]: userLib.defaultTrainer}];
            this.setState({rowData: obj});
        }
    }

    createTrainer(trainer) {
        let attrib;
        for (attrib in trainer) {
            if (Object.prototype.hasOwnProperty.call(trainer, attrib)) {
                if ("" === attrib) {
                }
                attrib = null;
            }
        }
        // add captcha token
        trainer.captchaToken = this.props.captchaToken;

        return API.post("pumps", "/trainers", {
            body: trainer
        });
    }

    handleSubmit = async event => {
        event.preventDefault();

        this.gridApi.stopEditing();
        if (validateFormTrainer(this)) {
            this.setState({isLoading: true});
            let element;
            try {
                element = this.gridApi.getDisplayedRowAtIndex(0).data;
                await this.createTrainer(element);
                alert('Success. An email has been sent to the Trainer to inform him/her about his/her ' +
                    'CamAPS trainer registration.');
                // reload data
                this.props.setRowDataTrainers([]);
                this.props.history.push("/trainers");
            } catch (e) {
                API.handleApiErrorWithAlert(e, this);
                this.setState({isLoading: false});
            }
            this.props.getNewCaptchaToken();
        }
    };

    render() {
        return (
            <div className="NewTrainer">
                <form onSubmit={this.handleSubmit}>
                    <div
                        id="pumpGrid"
                        style={this.state.style}
                        className="ag-theme-balham"
                    >
                        <AgGridReact
                            columnDefs={this.state.columnDefs}
                            defaultColDef={this.state.defaultColDef}
                            getRowHeight={this.state.getRowHeight}
                            onGridReady={this.onGridReady}
                            enableCellTextSelection={true}
                            singleClickEdit={true}
                            rowData={this.state.rowData}
                            headerHeight={58}
                        />
                    </div>

                    <LoaderButton
                        block
                        bsStyle="primary"
                        bsSize="large"
                        // disabled={!this.validateForm()}
                        type="submit"
                        isLoading={this.state.isLoading}
                        text="Create"
                        loadingText="Creating…"
                    />
                </form>
            </div>
        );
    }
}
